import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Loading } from '../components/Loading';
import { fetchUserUserRecommend } from './ducks/userRecommend';
import { RecommendBookList } from './RecommendBookList';
import { ErrorMessage } from 'app/recommend/ErrorMessage';

const UserRecommend = () => {
    const dispatch = useDispatch();
    const { school } = useParams();
    const userRecommend = useSelector(state => state.userRecommend);
    const auth = useSelector(state => state.auth);
    const [tabName, setTabName] = useState('Like');

    useEffect(() => {
        if (!auth.authenticated) return;
        dispatch(fetchUserUserRecommend());
    }, [dispatch, auth]);

    const content = useMemo(() => {
        if (!auth.authenticated) return <ErrorMessage message="로그인을 해주세요!" link={`/${school}/signin`} />;
        if (auth.grade <= 0) return <ErrorMessage message="1 ~ 6학년만<br/>맞춤 추천 됩니다!" />;
        if (userRecommend.loading) return <Loading />;
        if (null !== userRecommend.message) return <ErrorMessage message={userRecommend.message} />;
        return <RecommendBookList className="like" list={userRecommend[`list${tabName}`]} />;
    }, [auth, school, userRecommend, tabName]);



    return (
        <div className="userRecommend" id="userRecommend">
            <h2 className="subTitle">맞춤도서</h2>
            <div className="tab">
                <ul>
                    <li className={`like ${tabName === 'Like' ? 'active' : ''}`} onClick={() => setTabName('Like')}>
                        <h3 className="thirdTitle">내가 좋아 할 만한 책</h3>
                    </li>
                    <li className={`help ${tabName === 'Help' ? 'active' : ''}`} onClick={() => setTabName('Help')}>
                        <h3 className="thirdTitle">내게 도움이 될만한 책</h3>
                    </li>
                </ul>
            </div>
            {content}
            <div className="dashedLine"></div>
        </div>
    );
}
export default UserRecommend;
